import ConfirmDialog from './ConfirmDialog';
import './ConfirmDialog.scss';

export default ConfirmDialog;
